import { extendObservable } from 'mobx';

var DEFAULT_TYPE = '__DEFAULT_TYPE__';
var META_FIELD = '__META__'; // Note: Hardcoded in interfaces/IRawModel

function mapItems(data, fn) {
    if (data instanceof Array) {
        // tslint:disable-next-line:no-unnecessary-callback-wrapper
        return data.map(function (item) { return fn(item); });
    }
    return data === null ? null : fn(data);
}
/**
 * Flatten a 2D array to a single array
 *
 * @export
 * @template T
 * @param {Array<Array<T>|T>} data Arrays to flatten
 * @returns {Array<T>} Flattened array
 */
function flatten(data) {
    var _a;
    return (_a = []).concat.apply(_a, data);
}
/**
 * Check if the given variable is an array with at least one falsy value
 *
 * @export
 * @param {any} value A variable to check
 * @returns {boolean} The given variable is an array with at least one falsy value
 */
function isFalsyArray(value) {
    return value instanceof Array && !value.every(Boolean);
}
function undefinedGetter() {
    return undefined;
}
function defaultSetter() {
    throw new Error('The setter is not defined for this property');
}
/**
 * Add a computed property to an observable object
 *
 * @export
 * @param {object} obj Observable object
 * @param {string} key Property to add
 * @param {() => any} getter Getter function
 * @param {(value: any) => void} [setter] Setter function
 */
function assignComputed(obj, key, getter, setter) {
    var _a;
    if (getter === void 0) { getter = undefinedGetter; }
    if (setter === void 0) { setter = defaultSetter; }
    var admin = Symbol.for('datx administration');
    if (!obj.hasOwnProperty(admin)) {
        Object.defineProperty(obj, admin, {
            configurable: false,
            enumerable: false,
            value: {},
        });
    }
    obj[admin]["get__" + key] = getter;
    obj[admin]["set__" + key] = setter;
    if (!obj.hasOwnProperty(key)) {
        extendObservable(obj, (_a = {},
            Object.defineProperty(_a, key, {
                get: function () {
                    return obj[admin]["get__" + key]();
                },
                enumerable: true,
                configurable: true
            }),
            Object.defineProperty(_a, key, {
                set: function (val) {
                    if (setter) {
                        obj[admin]["set__" + key](val);
                    }
                },
                enumerable: true,
                configurable: true
            }),
            _a));
    }
}
function error() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    // tslint:disable-next-line:no-console
    console.error.apply(console, ["[datx error]"].concat(args));
}
function warn() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'test') {
        return;
    }
    // tslint:disable-next-line:no-console
    console.warn.apply(console, ["[datx warning]"].concat(args));
}
function deprecated() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'test') {
        return;
    }
    // tslint:disable-next-line:no-console
    console.warn.apply(console, ["[datx deprecated]"].concat(args));
}
function info() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'test') {
        return;
    }
    // tslint:disable-next-line:no-console
    console.info.apply(console, ["[datx info]"].concat(args));
}

export { DEFAULT_TYPE, META_FIELD, assignComputed, deprecated, error, flatten, info, isFalsyArray, mapItems, warn };
